import type { DamageReportResponse } from '@/shared/api';

/** Offene Meldungen als je eine Zeile, bestätigte nur als Zahl. */
export function ReportSummary({ reports }: { reports: DamageReportResponse[] }) {
  const pending = reports.filter((report) => report.acknowledgedAt === null);
  return (
    <>
      <b className="text-sm">{reports.length ? 'Meldungen' : 'Etwas nicht in Ordnung?'}</b>
      {pending.map((report) => (
        <p key={report.id} className="text-ink-soft text-[13px]">
          <b className={report.kind === 'Damage' ? 'text-sealwax' : 'text-ink'}>
            {report.kind === 'Damage' ? 'Schaden' : 'Fehlteil'}
          </b>{' '}
          · {report.title} · wartet auf Bestätigung
        </p>
      ))}
      {reports.length > pending.length && (
        <p className="text-ink-faint text-xs">{reports.length - pending.length} bestätigt</p>
      )}
    </>
  );
}
